//config.js
export const APP_VERSION = '1.0.50';